export function createRef(initialValue) {
  return {
    current: initialValue
  };
}